/**
 * Single source of truth for what each reader level can actually access.
 *
 * Every surface that explains the ladder (article gate, podcast gate,
 * membership pages, why-join, registration, CTAs) reads its wording here so
 * the promise is identical everywhere.
 */

export const ACCESS_COPY = {
  anonymous: {
    label: "Without an account",
    price: "€0",
    articles: "10 articles a month",
    podcasts: "No podcast episodes",
    line: "Without an account you can read 10 articles a month and cannot listen to The Retail Brief.",
    short: "10 articles a month, no podcasts",
  },
  free: {
    label: "Free account",
    price: "€0",
    articles: "Unlimited articles",
    podcasts: "1 podcast episode a month",
    line: "A free account gives you unlimited articles, one episode of The Retail Brief a month, the newsletter every Monday, Wednesday and Friday, and your My Retail feed.",
    short: "Unlimited articles, 1 podcast episode a month",
  },

  executive: {
    label: "Executive Membership",
    price: "€250 / year",
    articles: "Unlimited articles",
    podcasts: "Unlimited podcast episodes",
    line: "Executive Membership removes every cap: unlimited articles and podcasts, the complete Deal & Expansion Tracker, and full access to the Research desk, quarterly reports and the Retail Academy.",
    short: "Everything, no caps, including Research and the Retail Academy",
  },
} as const;

/** Ordered ladder for comparison blocks. */
export const ACCESS_LADDER = [
  ACCESS_COPY.anonymous,
  ACCESS_COPY.free,
  ACCESS_COPY.executive,
] as const;
